/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { useLocation } from "@gatsbyjs/reach-router"
import { Flowbite } from "flowbite-react"

import CustomNavbar from "./organisms/navbar"
import { theme } from "../styles/flowbite-theme"

import "../styles/application-scoped.scss"
import { Helmet } from "react-helmet"

const Layout = ({ children, topBanner }) => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      !window.location.href.includes("iframe")
    ) {
      window.fwSettings = {
        widget_id: 44000000297,
      }
      if (typeof window.FreshworksWidget !== "function") {
        var n = function () {
          n.q.push(arguments)
        }
        n.q = []
        window.FreshworksWidget = n
      }
    }
  }, [])

  return (
    <>
      <Helmet>
        {typeof window === "undefined" ||
        (typeof window !== "undefined" &&
          !window.location.href.includes("iframe")) ? (
          <script
            type="text/javascript"
            src="https://widget.freshworks.com/widgets/44000000297.js"
            async
          ></script>
        ) : null}
      </Helmet>
      <div className="tw-scope">
        <Flowbite theme={{ theme }}>
          <CustomNavbar pathname={pathname} topBanner={topBanner} />
          <div className="scss-scope">
            <div className="wrapper">{children}</div>
          </div>
        </Flowbite>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
